import React from 'react';

import { PortalPortlet } from '@interlayer/js/components/system/Portlet/buzz/components/PortalPortlet';

import { useFindAdditionalConfig } from './hooks/useFindAdditionalConfig';

export const PortalBanner: React.FC<{ portletConfig: any }> = ({ portletConfig }) => {
    const findAdditionalConfig = useFindAdditionalConfig();

    return (
        <PortalPortlet
            portletConfig={portletConfig}
            findAdditionalConfig={findAdditionalConfig}
        />
    );
};
